import { AppNav } from '@/components/AppNav';
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from '@/components/ui/input-otp';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { generatePath } from 'react-router-dom';
import { STAGE_ROUTE } from '@/routes/consts';
import { useGetEventIdByCodeLazyQuery } from '@/generated/graphql';

export function EventStageCodeScreen() {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const [getEventIdByCode, { loading }] = useGetEventIdByCodeLazyQuery();

  const handleChange = (value: string) => {
    setValue(value);
    setError(false); // Clear error when user types

    if (value.length === 4) {
      // verify code is valid
      getEventIdByCode({
        variables: {
          code: value,
        },
      })
        .then(({ data }) => {
          if (data?.eventByCode?.success && data.eventByCode.eventId) {
            // redirect to stage
            navigate(
              generatePath(STAGE_ROUTE, { id: data.eventByCode.eventId }),
            );
          } else {
            setError(true);
          }
        })
        .catch(() => {
          setError(true);
        });
    }
  };

  return (
    <div
      data-name="EVENT_STAGE_CODE_SCREEN"
      className="flex min-h-screen w-full flex-col items-center justify-start"
    >
      <AppNav />
      <div
        data-name="EVENT_STAGE_CODE_SCREEN_CONTENT"
        className="flex flex-1 flex-col items-center justify-center gap-4"
      >
        <h1 className="text-4xl font-bold">🍾 Enter Your Screen Code 🍾</h1>
        <p className="text-lg text-muted-foreground">
          Enter the code for your screen to continue.
        </p>
        <InputOTP
          value={value}
          maxLength={4}
          name="screen-code"
          autoComplete="off"
          autoFocus
          onChange={handleChange}
          disabled={loading}
        >
          <InputOTPGroup>
            <InputOTPSlot index={0} />
            <InputOTPSlot index={1} />
            <InputOTPSlot index={2} />
            <InputOTPSlot index={3} />
          </InputOTPGroup>
        </InputOTP>

        {/* Error message with fade transition */}
        <div
          className={`transition-opacity duration-300 ${
            error ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <p className="text-center text-sm text-destructive">
            Invalid code. Please try again.
          </p>
        </div>

        {/* Loading indicator */}
        <div
          className={`flex justify-center transition-opacity duration-300 ${
            loading ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="h-6 w-6 animate-spin rounded-full border-b-2 border-primary"></div>
        </div>
      </div>
    </div>
  );
}
